import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../core/services/config/config.service';
import { UtilityService } from '../../../../core/services/utility/utility.service';
import { PatientHealthConcern } from '../../models/patient-health-concern';

@Injectable({
  providedIn: 'root',
})
export class PatientHealthConcernsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  patientHealthConcernsEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/PatientHealthConcerns`;

  getHealthConcernsByPatientId(patientId: number): Observable<PatientHealthConcern[]> {
    const url = `${this.patientHealthConcernsEndpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientHealthConcern[]>(url);
  }

  getHealthConcernById(patientHealthConcernId: number, patientId: number): Observable<PatientHealthConcern> {
    const url = `${this.patientHealthConcernsEndpoint}/${patientHealthConcernId}?patientId=${patientId}`;
    return this.utilityService.getRequest<PatientHealthConcern>(url);
  }

  postPrintEvent(patientId: number, ids: number[]): Observable<void> {
    const url = `${this.patientHealthConcernsEndpoint}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, { ids }, { skipGlobalError: true });
  }

  postDetailPrintEvent(patientId: number, patientHealthConcernId: number): Observable<void> {
    const url = `${this.patientHealthConcernsEndpoint}/${patientHealthConcernId}/PrintEvent?patientId=${patientId}`;
    return this.utilityService.postRequest<void>(url, null, { skipGlobalError: true });
  }
}
